import React, { Component } from "react";
import {
Layout,
Button,
Row,
Col,
Card,
Avatar,
Input,
} from "antd";
import "antd/dist/antd.css";
import { withRouter } from "react-router-dom";
import { CheckCircleOutlined } from "@ant-design/icons";
import axios from "axios";

import { withAppContext } from "../../store/contextStore";
import { noAuthadd } from "../../api/Apis";
import { sendHomeClaimedWebhook, sendHomeAdvisorVisitRequestedWebhook } from "../../utils/ghlWebhooks";
import buildingLogo from "../../images/buildingLogo.png";
import buyHome from "../../images/buyHome.png";
import sellHome from "../../images/sellHome.png";
import agentHome from "../../images/agentHome.png";
import offerHome from "../../images/offerHome.png";

const { Content } = Layout;

/* ─── Design tokens matching AI site ─────────────────────── */
const T = {
navy:    "#1A2280",
navyD:   "#12185a",
navyM:   "#2A3390",
green:   "#1A5C40",
gold:    "#D4921A",
goldL:   "#FFD98E",
white:   "#FFFFFF",
offWhite:"#F8F9FF",
g100:    "#F0F2F8",
g400:    "#888",
g600:    "#555",
dark:    "#1a1a2e",
red:     "#F75B47",
};

// Picks the first candidate that's an actual string/number and coerces it.
// Mirrors the helper of the same name in HomePortalPage.js / HomeBuddha.js —
// guards against a property-data field coming back as an object and
// silently stringifying to "[object Object]".
function pickStr(...candidates) {
  for (const v of candidates) {
    if (v && (typeof v === "string" || typeof v === "number")) return String(v);
  }
  return "";
}

const styles = {
/* Hero */
heroWrap: {
background: `linear-gradient(135deg, ${T.navy} 0%, ${T.navyM} 55%, ${T.green} 100%)`,
padding: "0 0 48px",
position: "relative",
overflow: "hidden",
  },
heroBgCircle1: {
position: "absolute", top: "-120px", right: "-80px",
width: "420px", height: "420px", borderRadius: "50%",
background: "rgba(255,255,255,0.04)", pointerEvents: "none",
  },
heroBgCircle2: {
position: "absolute", bottom: "-60px", left: "-60px",
width: "300px", height: "300px", borderRadius: "50%",
background: "rgba(212,146,26,0.08)", pointerEvents: "none",
  },
goldBar: {
height: "4px",
background: `linear-gradient(90deg, ${T.gold}, ${T.goldL}, ${T.gold})`,
  },
heroPadding: { padding: "64px 24px 56px", textAlign: "center" },
heroInner: { maxWidth: "720px", margin: "0 auto" },
eyebrow: {
display: "inline-block",
background: "rgba(212,146,26,0.18)",
border: `1px solid rgba(212,146,26,0.45)`,
borderRadius: "50px",
padding: "4px 16px",
fontSize: "11px",
fontWeight: "800",
color: T.gold,
letterSpacing: "0.1em",
textTransform: "uppercase",
marginBottom: "16px",
fontFamily: "'DM Sans', sans-serif",
  },
heroTitle: {
fontSize: "clamp(28px, 4vw, 52px)",
fontFamily: "'DM Sans', sans-serif",
color: T.white,
fontWeight: "900",
lineHeight: "1.15",
marginBottom: "16px",
letterSpacing: "-0.02em",
  },
heroSub: {
fontSize: "clamp(15px, 1.7vw, 20px)",
color: "rgba(255,255,255,0.88)",
lineHeight: "1.65",
fontFamily: "'DM Sans', sans-serif",
fontWeight: "400",
marginBottom: "28px",
maxWidth: "700px",
marginLeft: "auto",
marginRight: "auto",
  },
heroMicro: {
marginTop: "14px", fontSize: "12px",
color: "rgba(255,255,255,0.55)",
fontFamily: "'DM Sans', sans-serif",
  },
/* Numbered section label (What / Why / How) — this IS the section's main
   heading, intentionally much larger/bolder than a typical eyebrow label,
   per Tracy's feedback that visitors were skimming past "What / Why / How"
   too quickly to register the page's structure. */
stepLabel: {
display: "inline-flex", alignItems: "center", gap: "14px",
fontSize: "clamp(26px, 4vw, 44px)", fontWeight: "900",
color: T.green, textTransform: "none",
letterSpacing: "-0.01em", lineHeight: "1.15", marginBottom: "14px",
fontFamily: "'DM Sans', sans-serif",
  },
stepLabelNum: {
display: "inline-flex", alignItems: "center", justifyContent: "center",
width: "44px", height: "44px", minWidth: "44px", borderRadius: "50%",
background: T.green, color: T.white,
fontSize: "20px", fontWeight: "900",
  },
/* Brand promise strip (kept for the badges used inside the hero wrap-up) */
brandBadge: {
display: "inline-flex", alignItems: "center", gap: "8px",
background: T.white, border: `1.5px solid ${T.g100}`,
borderRadius: "50px", padding: "10px 20px",
fontFamily: "'DM Sans', sans-serif", fontSize: "14px", fontWeight: "800", color: T.dark,
  },
/* CTA pill */
joinBtn: {
background: `linear-gradient(135deg, ${T.red}, #c04030)`,
border: "none", borderRadius: "50px",
padding: "0 36px", height: "52px",
fontFamily: "'DM Sans', sans-serif",
fontSize: "15px", fontWeight: "900",
color: T.white, letterSpacing: "0.04em",
boxShadow: "0 4px 20px rgba(247,91,71,0.4)",
cursor: "pointer",
  },
goldBtn: {
display: "inline-flex", alignItems: "center", gap: "8px",
background: T.gold, color: "#2A1600",
border: "none", borderRadius: "50px", padding: "0 32px", height: "54px",
fontFamily: "'DM Sans', sans-serif",
fontSize: "16px", fontWeight: "900",
boxShadow: "0 4px 20px rgba(212,146,26,0.45)",
letterSpacing: "0.02em", cursor: "pointer",
  },
/* "What is Home Buddha" option cards */
whatSection: { padding: "56px 24px", background: T.white },
optionCard: {
background: T.offWhite,
border: `1.5px solid ${T.g100}`,
borderRadius: "16px",
padding: "26px 24px",
height: "100%",
  },
optionBadge: {
display: "inline-block",
borderRadius: "50px",
padding: "4px 14px",
fontSize: "11px", fontWeight: "800",
marginBottom: "12px",
fontFamily: "'DM Sans', sans-serif",
textTransform: "uppercase", letterSpacing: "0.06em",
  },
optionTitle: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "18px", fontWeight: "900",
color: T.dark, marginBottom: "8px",
  },
optionBody: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "13px", color: T.g600,
lineHeight: "1.7", marginBottom: "14px",
  },
optionLink: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "13px", fontWeight: "800",
textDecoration: "underline", cursor: "pointer", background: "none", border: "none", padding: 0,
  },
/* AI Banner */
aiBanner: {
background: `linear-gradient(135deg, ${T.navy} 0%, ${T.navyM} 60%, ${T.green} 100%)`,
borderRadius: "16px",
padding: "24px 24px 20px",
margin: "0 0 24px",
boxShadow: "0 4px 24px rgba(26,34,128,0.18)",
  },
aiBannerLeft: { display: "flex", alignItems: "flex-start", gap: "14px", marginBottom: "16px" },
aiBannerEyebrow: {
color: T.gold, fontSize: "10px", fontWeight: "800",
textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: "3px",
fontFamily: "'DM Sans', sans-serif",
  },
aiBannerTitle: {
color: T.white, fontSize: "17px", fontWeight: "900",
marginBottom: "6px", fontFamily: "'DM Sans', sans-serif",
lineHeight: "1.3",
  },
aiBannerSub: {
color: "rgba(255,255,255,0.75)", fontSize: "12px",
lineHeight: "1.6", fontFamily: "'DM Sans', sans-serif",
  },
aiBannerBtn: {
display: "block",
background: T.gold, color: "#2A1600",
borderRadius: "50px", padding: "13px 24px",
fontWeight: "900", fontSize: "15px",
textDecoration: "none", textAlign: "center",
border: "none", cursor: "pointer",
fontFamily: "'DM Sans', sans-serif",
width: "100%", boxSizing: "border-box",
boxShadow: "0 4px 16px rgba(212,146,26,0.35)",
  },
/* Feature cards */
featureGrid: {
background: T.offWhite,
padding: "48px 24px",
  },
featureCard: {
background: T.white,
borderRadius: "16px",
border: `1.5px solid ${T.g100}`,
padding: "28px 24px",
height: "100%",
textAlign: "center",
transition: "box-shadow .2s, transform .2s",
cursor: "default",
  },
featureIcon: {
width: "64px", height: "64px",
borderRadius: "16px",
background: T.offWhite,
display: "flex", alignItems: "center", justifyContent: "center",
margin: "0 auto 16px",
border: `1.5px solid ${T.g100}`,
  },
featureTitle: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "16px", fontWeight: "800",
color: T.dark, marginBottom: "8px",
  },
featureBody: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "13px", color: T.g600,
lineHeight: "1.65", textAlign: "center",
  },
/* Stats strip */
statsStrip: {
background: T.navy,
padding: "32px 24px",
display: "flex",
justifyContent: "center",
flexWrap: "wrap",
gap: "0",
  },
statItem: {
textAlign: "center",
padding: "0 32px",
borderRight: "1px solid rgba(255,255,255,0.12)",
minWidth: "140px",
  },
statNum: {
color: T.gold, fontSize: "32px", fontWeight: "900",
fontFamily: "'DM Sans', sans-serif", lineHeight: "1",
marginBottom: "6px",
  },
statLabel: {
color: "rgba(255,255,255,0.72)", fontSize: "12px",
fontFamily: "'DM Sans', sans-serif", fontWeight: "600",
textTransform: "uppercase", letterSpacing: "0.06em",
  },
/* "Why we launched" section */
whySection2: { padding: "56px 24px 48px", background: T.offWhite },
riskCard: {
background: T.white,
borderRadius: "14px",
border: `1.5px solid ${T.g100}`,
padding: "22px 20px",
height: "100%",
  },
riskIconWrap: {
width: "44px", height: "44px", minWidth: "44px",
borderRadius: "12px",
display: "flex", alignItems: "center", justifyContent: "center",
fontSize: "20px",
marginBottom: "12px",
  },
riskCardTitle: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "15px", fontWeight: "800",
color: T.dark, marginBottom: "6px",
  },
riskCardBody: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "13px", color: T.g600,
lineHeight: "1.65",
  },
/* How section */
howSection: { padding: "56px 24px", background: T.white },
/* Why section (pills, further down) */
whySection: { padding: "56px 24px" },
sectionEyebrow: {
fontSize: "11px", fontWeight: "800",
color: T.green, textTransform: "uppercase",
letterSpacing: "0.12em", marginBottom: "8px",
fontFamily: "'DM Sans', sans-serif",
display: "block",
  },
sectionTitle: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "clamp(22px, 2.6vw, 36px)",
fontWeight: "900", color: T.dark,
lineHeight: "1.2", marginBottom: "8px",
letterSpacing: "-0.01em",
  },
sectionSub: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "15px", color: T.g400,
lineHeight: "1.7", maxWidth: "560px",
  },
pillCard: {
background: T.offWhite,
borderRadius: "14px",
border: `1.5px solid ${T.g100}`,
padding: "22px 20px",
display: "flex", gap: "14px",
alignItems: "flex-start",
marginBottom: "14px",
  },
pillIcon: {
width: "42px", height: "42px", minWidth: "42px",
borderRadius: "10px", background: T.navy,
display: "flex", alignItems: "center", justifyContent: "center",
fontSize: "20px",
  },
pillTitle: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "14px", fontWeight: "800",
color: T.dark, marginBottom: "4px",
  },
pillBody: {
fontFamily: "'DM Sans', sans-serif",
fontSize: "12px", color: T.g600,
lineHeight: "1.6",
  },
/* Bottom CTA */
bottomCTA: {
background: `linear-gradient(135deg, ${T.navy}, ${T.navyM} 60%, ${T.green})`,
padding: "56px 24px",
textAlign: "center",
  },
};

class Home extends Component {
constructor(props) {
super(props);
this.state = {
addressInput:    "",
addressLoading:  false,
addressResult:   null,
addressError:    null,
// null | "confirm" | "edit" | "email" | "schedule" | "confirmed"
identityStep:     null,
manualFirstName:  "",
manualLastName:   "",
pendingClaim:     null,
claimEmail:       "",
claimSubmitting:  false,
// New: optional $99 Home Advisor visit scheduling, offered at the end
// of the same claim flow rather than as a separate funnel.
showVisitFields:  false,
visitDate:        "",
visitTimeWindow:  "",
visitPhone:       "",
    };
  }

componentDidMount = () => {
this.getIpAddress();
  };

getIpAddress = () => {
axios
      .get(process.env.REACT_APP_IPADDRESS)
      .then((result) => { this.addIpAddress(result.data); })
      .catch((error) => console.log("Error :", error));
  };

addIpAddress = async (data) => {
const payload = { entityData: data };
try {
const response = await noAuthadd("ipAddressAnalytics", payload);
console.log(response);
    } catch (error) {
console.log("Error :", error);
    }
  };

goTo = () => {
document.body.scrollTop = 0;
document.documentElement.scrollTop = 0;
this.props.history.push(`/register`);
  };

// Same smooth-scroll-with-buffer approach as HomePortalPage.js — a plain
// scrollIntoView can end up cutting off the target's own heading on mobile
// when the browser chrome collapses mid-scroll.
scrollToEl = (elId, offset = 16) => {
const el = document.getElementById(elId);
if (!el) return;
const targetY = Math.max(0, window.pageYOffset + el.getBoundingClientRect().top - offset);
window.scrollTo({ top: targetY, behavior: "smooth" });
  };

// Every "book the visit" / "get started" CTA on this page now scrolls down
// to the embedded claim flow below instead of navigating to /homeportal —
// so a visitor never has to leave this page (and risk getting lost) to
// claim their home or request a Home Advisor visit.
scrollToClaim = () => {
this.scrollToEl("claimAddressBox");
  };

openAITools = (e) => {
e.preventDefault();
const base = "https://ai.myhomebuddha.com?mode=buyer";
const userLogin = localStorage.getItem("userLogin");
if (userLogin) {
const { Auth } = require("aws-amplify");
Auth.currentSession()
        .then((session) => {
const token = session.getIdToken().getJwtToken();
window.open(`${base}&token=${encodeURIComponent(token)}`, "_blank");
        })
        .catch(() => window.open(base, "_blank"));
    } else {
window.open(base, "_blank");
    }
  };

/* ── Claim flow (ported from HomePortalPage.js, same shape/behavior,
       plus the new optional visit-scheduling step) ──────────────── */

extractOwnerName = (data) => {
if (!data) return null;
const s = data.subject || {};
const p = data.propData || {};
const asStr = (v) => (typeof v === "string" ? v : null);
const rentcastNames = p.owner && Array.isArray(p.owner.names) ? p.owner.names : null;
const candidates = [
asStr(rentcastNames && rentcastNames[0]),
asStr(s.ownerName), asStr(s.owner),
asStr(p.owner),
asStr(p.ownerName), asStr(p.owner1FullName),
[p.owner1FirstName, p.owner1LastName].filter(Boolean).join(" "),
[p.ownerFirstName, p.ownerLastName].filter(Boolean).join(" "),
asStr(data.ownerName), asStr(data.owner),
    ]
.filter(Boolean)
.map(v => String(v).trim())
.filter(v => v.length > 1);
if (!candidates.length) return null;
const full = candidates[0];
const parts = full.split(/\s+/);
return {
full,
first: parts[0] || "",
last:  parts.length > 1 ? parts.slice(1).join(" ") : "",
    };
  };

lookupAddress = async () => {
const address = (this.state.addressInput || "").trim();
if (!address) return;
this.setState({ addressLoading: true, addressError: null });
try {
const resp = await fetch("https://ai.myhomebuddha.com/.netlify/functions/property-data", {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify({ address }),
      });
let result = { address };
let owner = null;
let lookupError = null;
if (resp.ok) {
const data = await resp.json();
const s = data.subject || {};
const p = data.propData || {};
result = {
address,
yearBuilt:  pickStr(s.yearBuilt, p.yearBuilt),
squareFeet: pickStr(s.sqft, p.squareFootage, p.livingArea),
bedrooms:   pickStr(s.beds, p.bedrooms),
bathrooms:  pickStr(s.baths, p.bathrooms),
county:     pickStr(p.county),
state:      pickStr(p.state, p.stateCode),
zipCode:    pickStr(p.zipCode, p.zip, p.postalCode),
        };
owner = this.extractOwnerName(data);
      } else {
lookupError = "Couldn't auto-fill your home's details — you can still continue and enter them yourself.";
      }
const parts = address.split(",").map(x => x.trim());
result.city = parts.length >= 2 ? parts[1] : "";
result.ownerMatch = owner;
this.setState({
addressResult:   result,
addressLoading:  false,
addressError:    lookupError,
identityStep:    "confirm",
manualFirstName: owner ? owner.first : "",
manualLastName:  owner ? owner.last  : "",
      });
localStorage.setItem("mhb_pending_home", JSON.stringify(result));
    } catch (err) {
console.error("lookupAddress:", err);
this.setState({ addressLoading: false, addressError: "Couldn't look up that address — please try again." });
    }
  };

handleConfirmOwnerMatch = () => {
const owner = this.state.addressResult && this.state.addressResult.ownerMatch;
if (!owner) return;
this.setState({
identityStep: "email",
pendingClaim: { firstName: owner.first, lastName: owner.last, ownerMatch: true, matchedOwnerName: owner.full },
    });
  };

handleRejectOwnerMatch = () => {
this.setState({ identityStep: "edit" });
  };

handleManualNameSubmit = () => {
const firstName = (this.state.manualFirstName || "").trim();
const lastName  = (this.state.manualLastName  || "").trim();
if (!firstName || !lastName) return;
const owner = this.state.addressResult && this.state.addressResult.ownerMatch;
this.setState({
identityStep: "email",
pendingClaim: { firstName, lastName, ownerMatch: false, matchedOwnerName: owner ? owner.full : null },
    });
  };

// Email step now hands off to the new "schedule" step instead of
// submitting the claim immediately — the webhook still only fires once,
// from submitHomeClaim, after the visit question (below) is resolved.
handleEmailSubmit = () => {
const email = (this.state.claimEmail || "").trim();
if (!this.state.pendingClaim) return;
this.setState({
pendingClaim: { ...this.state.pendingClaim, email: email || null },
identityStep: "schedule",
    });
  };

handleSkipEmail = () => {
if (!this.state.pendingClaim) return;
this.setState({
pendingClaim: { ...this.state.pendingClaim, email: null },
identityStep: "schedule",
    });
  };

// "Not right now" on the visit-scheduling step — claim still submits,
// just with no visit requested.
handleDeclineVisit = () => {
if (!this.state.pendingClaim) return;
this.submitHomeClaim({ ...this.state.pendingClaim, wantsVisit: false });
  };

// "Request My Visit" — only reachable once date + phone are filled in
// (see the disabled prop on the button in render).
handleRequestVisit = () => {
if (!this.state.pendingClaim) return;
this.submitHomeClaim({
      ...this.state.pendingClaim,
wantsVisit: true,
visitDate: (this.state.visitDate || "").trim(),
visitTimeWindow: (this.state.visitTimeWindow || "").trim(),
visitPhone: (this.state.visitPhone || "").trim(),
    });
  };

// Fires the "home_claimed" webhook exactly once. When the visitor also
// opted into the $99 Home Advisor visit, ALSO fires the dedicated
// "home_advisor_visit_requested" webhook alongside it — kept as its own
// event/workflow (per Tracy: each event gets its own GHL workflow) rather
// than bolted onto the home_claimed payload, since "wants a visit and
// needs a call to confirm a time" should drive a different, more
// time-sensitive advisor action than a plain claim.
submitHomeClaim = async ({ firstName, lastName, ownerMatch, matchedOwnerName, email, wantsVisit, visitDate, visitTimeWindow, visitPhone }) => {
const r = this.state.addressResult || {};
this.setState({ claimSubmitting: true });
try {
await sendHomeClaimedWebhook({
firstName, lastName, ownerMatch, matchedOwnerName, email,
address: r.address, city: r.city, state: r.state, zipCode: r.zipCode,
yearBuilt: r.yearBuilt, squareFeet: r.squareFeet, bedrooms: r.bedrooms, bathrooms: r.bathrooms,
      });
if (wantsVisit) {
await sendHomeAdvisorVisitRequestedWebhook({
firstName, lastName, email,
phone: visitPhone,
address: r.address, city: r.city, state: r.state, zipCode: r.zipCode,
preferredVisitDate: visitDate,
preferredVisitTimeWindow: visitTimeWindow,
          });
      }
    } finally {
const updatedPending = {
        ...r, firstName, lastName,
email: email || r.email || null,
ownerMatchConfirmed: ownerMatch,
wantsVisit: !!wantsVisit,
      };
localStorage.setItem("mhb_pending_home", JSON.stringify(updatedPending));
this.setState({
claimSubmitting: false,
identityStep: "confirmed",
addressResult: updatedPending,
pendingClaim: null,
showVisitFields: false,
      });
    }
  };

render() {
const features = [
      {
img: buyHome, alt: "Buy a Home",
title: "Buy a Home",
body: "Browse MLS and Off MLS listings. Choose to connect with the seller, listing agent, or a local buyer's agent who works for you. Full transparency, your way.",
      },
      {
img: sellHome, alt: "Sell a Property",
title: "Sell a Property",
body: "List for free, off-market or on. Set your terms and timeline. Search for matching buyer profiles — cash buyers, investors, and more — without the MLS pressure.",
      },
      {
img: agentHome, alt: "Agent Services",
title: "Agent Services",
body: "Create coming-soon listings, private sales, and buyer profiles. Branded AI reports. Get matched with motivated buyers and sellers before they hit the open market.",
      },
      {
img: offerHome, alt: "Business Services",
title: "Business Services",
body: "Join as a vendor and connect your business directly to buyers, sellers, and agents. One platform, one audience, exponential reach.",
      },
    ];

const riskItems = [
      {
icon: "🔥", color: T.red,
title: "Prevent Fire Hazards",
body: "Faulty wiring, dryer lint buildup, overloaded panels, space heater misuse — the warning signs are easy to miss until it's too late. A trained eye catches them early.",
      },
      {
icon: "💧", color: T.red,
title: "Stop Water Damage Before It Starts",
body: "Slow leaks, failing sump pumps, and aging supply lines are the #1 cause of homeowner insurance claims — most are preventable if someone catches them in time.",
      },
      {
icon: "🦠", color: T.red,
title: "Avoid Mold & Water-Borne Illness",
body: "Hidden moisture behind walls, under floors, and in crawlspaces can trigger mold and health issues for your family long before you ever see or smell it.",
      },
      {
icon: "💰", color: T.gold,
title: "Protect Your Budget",
body: "Know what actually needs attention now versus what can wait — so small, inexpensive fixes don't turn into $20,000 emergencies down the road.",
      },
      {
icon: "📈", color: T.navy,
title: "Make Decisions That Build Value",
body: "Not every upgrade pays off. Get an honest, independent read on which improvements actually increase what your home is worth — and which don't.",
      },
      {
icon: "🔧", color: T.navy,
title: "Extend The Life Of Your Home's Systems",
body: "Your roof, HVAC, water heater, and foundation all have a lifespan. Catching wear early — instead of finding out the hard way — can add years to each one.",
      },
    ];

const pillItems = [
      {
icon: "🔍",
title: "Fully Transparent Home Search",
body: "You decide who you speak to — listing agent, buyer's agent, or seller directly. No smoke and mirrors. No shotgun inquiries to five agents at once.",
      },
      {
icon: "🏚️",
title: "Off-Market Opportunities",
body: "Agents and sellers add listings you won't find anywhere else: coming-soon, private sales, 'would sell for right fit.' Find your perfect home before it goes public.",
      },
      {
icon: "🤖",
title: "AI-Powered Research & Tools",
body: "Full AI property research, verified market values, inspection analysis, home health scoring, buyer readiness checks, and agent-branded reports — all in one place.",
      },
      {
icon: "🏡",
title: "Homeowner Portal",
body: "Manage your home's health, track your wealth, and stay wise. Maintenance reminders, home value tracking, and AI-powered advice — your home working for you.",
      },
    ];

return (
      <>
        <Layout style={{ width: "100%", background: "#fff" }}>
          <Content>

            {/* ── HERO — brand-first, not "how" ─────────────────── */}
            <div style={styles.heroWrap}>
              <div style={styles.heroBgCircle1} />
              <div style={styles.heroBgCircle2} />
              <div style={styles.goldBar} />
              <div style={styles.heroPadding}>
                <div style={styles.heroInner}>
                  <div style={styles.eyebrow}>My Home Buddha™</div>
                  <h1 style={styles.heroTitle}>Every Home Needs It's Own "Home Buddha"</h1>
                  <p style={styles.heroSub}>
Imagine if your home had a brain attached to it. A brain that could help it's homeowner every day realize a safer, healthier, wealthier journey. My Home Buddha does exactly this. By claiming your home below, takes less than a minute, you unlock a lifetime of homeowner
benefits. Your Home Buddha helps you realize a healthier, safer, wealthier, and happier
homeownership experience in more ways than you could ever imagine. Think of it as your home's digital
twin — a twin with an AI powered brain behind it, that knows your home better than you do — and helps you with everything, from keeping
your home and family safe, to smart improvements, to renovation decisions, to sound advice, to ongoing savings on
local home services and products, and much more. Once you claim your home you can take it to the next level by building your homes digital twin by taking pictures of every room of your home and every mechanical component (takes 10-15 minutes). Whether you build it yourself for free, or let a local Home
Advisor build it for you for $99, your Home Buddha portal becomes your key to a lifetime of home owner value and help. 
                  </p>
                  <button style={styles.goldBtn} onClick={this.scrollToClaim}>
📍 Get Started — It's Free To Begin →
                  </button>
                  <div style={styles.heroMicro}>
Takes about 30 seconds to claim your home. No credit card required.
                  </div>
                </div>
              </div>
            </div>
            {/* ── END HERO ─────────────────────────────────── */}

            {/* ── 01 · WHAT IS HOME BUDDHA? ────────────────── */}
            <div style={styles.whatSection}>
              <div style={{ textAlign: "center", marginBottom: "32px" }}>
                <span style={styles.stepLabel}>
                  <span style={styles.stepLabelNum}>1</span> What Is Home Buddha?
                </span>
                <h2 style={{ ...styles.sectionTitle, margin: "0 auto 10px" }}>
Home Buddha Is Your Personalized Home Owner Portal — A Digital Twin Of Your Home Powered BY AI Intelligence
                </h2>
                <p style={{ ...styles.sectionSub, margin: "0 auto", maxWidth: "620px", textAlign: "center" }}>
Every Home Buddha Portal starts with Claiming Your Home & Building Your Digital Home Twin: It becomes the one place to track your home's health, value,
maintenance, and savings — for life. There are two ways to get yours built.
                </p>
              </div>
              <Row gutter={[20, 20]}>
                <Col xs={24} md={12}>
                  <div style={styles.optionCard}>
                    <span style={{ ...styles.optionBadge, background: T.g100, color: T.navy }}>Free</span>
                    <div style={styles.optionTitle}>🛠️ Claim Your Home &amp; Build It Yourself</div>
                    <p style={styles.optionBody}>
Answer a few quick questions about your home and let our AI powered platform build your Home Portal with you — free,
at your own pace. Then Take the Home Health Check-Up anytime to see exactly where your home stands. Is it safe? Is if healthy? See how your home stack up!
                    </p>
                    <button style={{ ...styles.optionLink, color: T.navy }} onClick={this.scrollToClaim}>
Get started below ↓
                    </button>
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div style={styles.optionCard}>
                    <span style={{ ...styles.optionBadge, background: `${T.gold}22`, color: "#8a5c0f" }}>$99 · Comes with a 100% cash back Guarantee </span>
                    <div style={styles.optionTitle}>🏠 Book Your Home Advisor Home Visit</div>
                    <p style={styles.optionBody}>
A local experienced Home Advisor stops by your home, walks through it with you, and builds your Home Portal onsite —
Your advisor provides you with an in-depth Home Health &amp; Safety Analysis to help you identify potential hazards you may not even be aware of. 
Your Home Advisor will also offer insight into renovations, value building improvements, etc. If you are Not happy with the visit for any reason we will refund your
$99 and you can keep your Home Portal for life, free.
                    </p>
                    <button style={{ ...styles.optionLink, color: "#8a5c0f" }} onClick={this.scrollToClaim}>
Get started below ↓
                    </button>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── 02 · WHY WE LAUNCHED HOME BUDDHA? ────────────── */}
            <div style={styles.whySection2}>
              <div style={{ textAlign: "center", marginBottom: "32px" }}>
                <span style={styles.stepLabel}>
                  <span style={styles.stepLabelNum}>2</span> Why We Launched Home Buddha
                </span>
                <h2 style={{ ...styles.sectionTitle, margin: "0 auto 10px" }}>
To Help Homeowners Realize A Happier, Healthier, Safer, Wealthier Homeownership Experience
                </h2>
                <p style={{ ...styles.sectionSub, margin: "0 auto", maxWidth: "620px", textAlign: "center" }}>
The founders of MyHomeBuddha.com launched the company out of a true and long time passion for home ownership.Every homeowner has questions. Every homeowner needs help. Owning a home shouldn't feel like guesswork and it shouldn't feel exhuasting. Most home disasters
don't happen overnight — they're the result of small things nobody caught in time. Here's what
having a Home Buddha actually protects you from:
                </p>
              </div>
              <Row gutter={[16, 16]}>
                {riskItems.map((r, i) => (
                  <Col key={i} xs={24} sm={12} md={8}>
                    <div style={styles.riskCard}>
                      <div style={{ ...styles.riskIconWrap, background: `${r.color}1A` }}>{r.icon}</div>
                      <div style={styles.riskCardTitle}>{r.title}</div>
                      <p style={styles.riskCardBody}>{r.body}</p>
                    </div>
                  </Col>
                ))}
              </Row>
              <div style={{ textAlign: "center", marginTop: "24px" }}>
                <button
onClick={this.scrollToClaim}
style={{
background: "none", border: "none", cursor: "pointer",
color: T.navy, fontWeight: "800", fontSize: "13px",
textDecoration: "underline", fontFamily: "'DM Sans', sans-serif",
                  }}
                >
See how we help ↓
                </button>
              </div>
            </div>

            {/* ── 03 · HOW WE HELP — the embedded claim flow ──── */}
            <div style={styles.howSection}>
              <div style={{ textAlign: "center", marginBottom: "28px" }}>
                <span style={styles.stepLabel}>
                  <span style={styles.stepLabelNum}>3</span> How We Help Homeowners?
                </span>
                <h2 style={{ ...styles.sectionTitle, margin: "0 auto 10px" }}>
We Help Homeowners by giving them an easy to use AI powered intelligent platform that helps them with all aspects of homeownership.
                </h2>
                <p style={{ ...styles.sectionSub, margin: "0 auto", maxWidth: "620px", textAlign: "center" }}>
It all starts by claiming your home below. Then you can choose to build your Home Portal yourself for free, or add
a $99 Home Advisor visit for hands-on help and an in-depth home health &amp; safety analysis.
                </p>
              </div>

              <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap", marginBottom: "24px" }}>
                <div style={styles.brandBadge}>🛠️ Build It Yourself — Free</div>
                <div style={styles.brandBadge}>🏠 Book A Home Advisor Visit — $99</div>
              </div>

              {/* ── Embedded claim box (same flow as HomePortalPage.js) ── */}
              <div
id="claimAddressBox"
style={{
background: T.offWhite, border: `2px solid ${T.gold}`, borderRadius: "12px",
padding: "26px 24px", maxWidth: "560px", margin: "0 auto", textAlign: "center",
                }}
              >
                <div style={{ fontSize: "24px", marginBottom: "6px" }}>📍</div>
                <div style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 800, color: T.navy, fontSize: "16px", marginBottom: "6px" }}>
Enter Your Address To Claim Your Home
                </div>
                <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "12px", color: T.g600, marginBottom: "14px", maxWidth: "440px", margin: "0 auto 14px", lineHeight: 1.6 }}>
Confirm your home details and start building your Home Portal — no commitment, no credit card.
                </div>
                <div style={{ display: "flex", gap: "8px", maxWidth: "440px", margin: "0 auto", flexWrap: "wrap", justifyContent: "center" }}>
                  <Input
placeholder="123 Main St, City, State ZIP"
value={this.state.addressInput}
onChange={e => this.setState({ addressInput: e.target.value })}
onPressEnter={this.lookupAddress}
style={{ flex: 1, minWidth: "220px", borderRadius: "8px" }}
                  />
                  <Button
type="primary"
loading={this.state.addressLoading}
onClick={this.lookupAddress}
style={{ borderRadius: "8px", background: T.gold, border: "none", fontWeight: 700, color: "#2A1600" }}
                  >
Confirm My Home Address
                  </Button>
                </div>

                {this.state.addressError && (
                  <div style={{ color: "#C53030", fontSize: "12px", marginTop: "10px", fontFamily: "'DM Sans', sans-serif" }}>
                    {this.state.addressError}
                  </div>
                )}

                {this.state.addressResult && (
                  <div style={{ background: "#F0FFF4", border: "1px solid #9AE6B4", borderRadius: "10px", padding: "14px 16px", marginTop: "14px", maxWidth: "440px", marginLeft: "auto", marginRight: "auto", textAlign: "left", fontFamily: "'DM Sans', sans-serif" }}>
                    <div style={{ fontSize: "12px", fontWeight: 700, color: "#276749", marginBottom: "6px" }}>✓ Found it! Here's a preview:</div>
                    <div style={{ fontSize: "12px", color: "#2D3748", lineHeight: 1.8 }}>
                      {this.state.addressResult.yearBuilt && <span>Built {this.state.addressResult.yearBuilt} · </span>}
                      {this.state.addressResult.squareFeet && <span>{this.state.addressResult.squareFeet} sq ft · </span>}
                      {this.state.addressResult.bedrooms && this.state.addressResult.bathrooms && <span>{this.state.addressResult.bedrooms} bed / {this.state.addressResult.bathrooms} bath</span>}
                    </div>

                    {/* Step 1a: confirm/reject the public-record owner match */}
                    {this.state.identityStep === "confirm" && (
                      <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid #C6F6D5" }}>
                        <div style={{ fontSize: "12px", fontWeight: 700, color: T.navy, marginBottom: "8px", lineHeight: 1.5 }}>
Public records show this home's owner as{" "}
<strong>{this.state.addressResult.ownerMatch ? this.state.addressResult.ownerMatch.full : "Not Found"}</strong>
                          {this.state.addressResult.ownerMatch ? " — is that you?" : ""}
                        </div>
                        <div style={{ display: "flex", gap: "8px" }}>
                          {this.state.addressResult.ownerMatch && (
                            <Button
type="primary"
loading={this.state.claimSubmitting}
onClick={this.handleConfirmOwnerMatch}
style={{ borderRadius: "50px", background: T.navy, border: "none", fontWeight: 700, flex: 1 }}
                            >
✓ Yes, that's me
                            </Button>
                          )}
                          <Button
onClick={this.handleRejectOwnerMatch}
disabled={this.state.claimSubmitting}
style={{ borderRadius: "50px", fontWeight: 700, flex: 1 }}
                          >
{this.state.addressResult.ownerMatch ? "That's not me" : "That's not me, name not found"}
                          </Button>
                        </div>
                      </div>
                    )}

                    {/* Step 1b: self-report name */}
                    {this.state.identityStep === "edit" && (
                      <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid #C6F6D5" }}>
                        <div style={{ fontSize: "12px", fontWeight: 700, color: T.navy, marginBottom: "8px" }}>
                          {this.state.addressResult.ownerMatch ? "No problem — what's your name?" : "We couldn't find an owner match on file — what's your name?"}
                        </div>
                        <div style={{ display: "flex", gap: "8px", marginBottom: "8px", flexWrap: "wrap" }}>
                          <Input
placeholder="First name"
value={this.state.manualFirstName}
onChange={e => this.setState({ manualFirstName: e.target.value })}
style={{ flex: 1, minWidth: "120px", borderRadius: "8px" }}
                          />
                          <Input
placeholder="Last name"
value={this.state.manualLastName}
onChange={e => this.setState({ manualLastName: e.target.value })}
style={{ flex: 1, minWidth: "120px", borderRadius: "8px" }}
                          />
                        </div>
                        <Button
type="primary"
block
loading={this.state.claimSubmitting}
disabled={!this.state.manualFirstName.trim() || !this.state.manualLastName.trim()}
onClick={this.handleManualNameSubmit}
style={{ borderRadius: "50px", background: T.navy, border: "none", fontWeight: 700 }}
                        >
Confirm &amp; Continue
                        </Button>
                      </div>
                    )}

                    {/* Step 2: email (optional) for local discounts */}
                    {this.state.identityStep === "email" && (
                      <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid #C6F6D5" }}>
                        <div style={{ fontSize: "12px", fontWeight: 700, color: T.navy, marginBottom: "8px", lineHeight: 1.5 }}>
Enter your email if you would like access to local monthly discounts on home products and services.
                        </div>
                        <Input
type="email"
placeholder="you@example.com"
value={this.state.claimEmail}
onChange={e => this.setState({ claimEmail: e.target.value })}
onPressEnter={this.handleEmailSubmit}
style={{ borderRadius: "8px", marginBottom: "8px" }}
                        />
                        <div style={{ display: "flex", gap: "8px" }}>
                          <Button
type="primary"
loading={this.state.claimSubmitting}
disabled={!this.state.claimEmail.trim()}
onClick={this.handleEmailSubmit}
style={{ borderRadius: "50px", background: T.navy, border: "none", fontWeight: 700, flex: 1 }}
                          >
✓ Send Me Local Discounts
                          </Button>
                          <Button
onClick={this.handleSkipEmail}
disabled={this.state.claimSubmitting}
style={{ borderRadius: "50px", fontWeight: 700, flex: 1 }}
                          >
No thanks
                          </Button>
                        </div>
                      </div>
                    )}

                    {/* Step 3 (new): optional $99 Home Advisor visit —
                        same step for both "funnels"; the only branch point
                        is whether they opt in here. */}
                    {this.state.identityStep === "schedule" && (
                      <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid #C6F6D5" }}>
                        <div style={{ fontSize: "12px", fontWeight: 700, color: T.navy, marginBottom: "6px", lineHeight: 1.5 }}>
🏠 Want hands-on help? Book your $99 Home Advisor visit.
                        </div>
                        <div style={{ fontSize: "12px", color: T.g600, marginBottom: "10px", lineHeight: 1.6 }}>
A local Home Advisor will walk your home with you and build your Home Portal together — plus
an in-depth Home Health &amp; Safety Analysis. Not happy with the visit? We refund your $99 and
you keep your Home Portal for life, free.
                        </div>

                        {!this.state.showVisitFields ? (
                          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                            <Button
type="primary"
onClick={() => this.setState({ showVisitFields: true })}
style={{ borderRadius: "50px", background: T.gold, border: "none", color: "#2A1600", fontWeight: 700, flex: 1 }}
                            >
🏠 Yes, Book My $99 Visit
                            </Button>
                            <Button
onClick={this.handleDeclineVisit}
loading={this.state.claimSubmitting}
style={{ borderRadius: "50px", fontWeight: 700, flex: 1 }}
                            >
Not Right Now
                            </Button>
                          </div>
                        ) : (
                          <>
                            <Input
placeholder="Preferred date (e.g. next Tuesday, 10/21)"
value={this.state.visitDate}
onChange={e => this.setState({ visitDate: e.target.value })}
style={{ borderRadius: "8px", marginBottom: "8px" }}
                            />
                            <Input
placeholder="Preferred time of day (mornings, afternoons, evenings)"
value={this.state.visitTimeWindow}
onChange={e => this.setState({ visitTimeWindow: e.target.value })}
style={{ borderRadius: "8px", marginBottom: "8px" }}
                            />
                            <Input
type="tel"
placeholder="Best phone number to reach you"
value={this.state.visitPhone}
onChange={e => this.setState({ visitPhone: e.target.value })}
style={{ borderRadius: "8px", marginBottom: "8px" }}
                            />
                            <div style={{ fontSize: "11px", color: T.g600, marginBottom: "8px", fontStyle: "italic" }}>
Our scheduling team will call you to confirm your exact appointment time.
                            </div>
                            <Button
type="primary"
block
loading={this.state.claimSubmitting}
disabled={!this.state.visitDate.trim() || !this.state.visitPhone.trim()}
onClick={this.handleRequestVisit}
style={{ borderRadius: "50px", background: T.navy, border: "none", fontWeight: 700 }}
                            >
Request My Visit →
                            </Button>
                          </>
                        )}
                      </div>
                    )}

                    {/* Step 4: identity (and optional visit request) captured — hand off to account creation */}
                    {this.state.identityStep === "confirmed" && (
                      <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid #C6F6D5" }}>
                        <div style={{ fontSize: "12px", color: "#276749", fontWeight: 700, marginBottom: "10px", lineHeight: 1.6 }}>
                          {this.state.addressResult.wantsVisit
? `🎉 Thanks, ${this.state.addressResult.firstName}! We've got your $99 Home Advisor visit request — our scheduling team will call you to confirm. Now let's create your free account so everything is saved.`
: `🎉 Thanks, ${this.state.addressResult.firstName}! Now it's time to create your account.`}
                        </div>
                        <Button
type="primary"
block
onClick={() => this.props.history.push({ pathname: "/register", state: { from: this.props.location.pathname } })}
style={{ borderRadius: "50px", background: T.navy, border: "none", fontWeight: 700 }}
                        >
Create My Free Account &amp; Save These Details →
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* ── STATS STRIP ─────────────────────────────── */}
            <div style={styles.statsStrip}>
              {[
                { num: "$99", label: "Home Advisor Visit" },
                { num: "Lifetime", label: "Home Portal, Free" },
                { num: "100%", label: "Satisfaction Guaranteed" },
                { num: "Free", label: "Local Savings & Offers" },
              ].map((s, i, arr) => (
                <div
key={i}
style={{
                    ...styles.statItem,
borderRight: i < arr.length - 1 ? "1px solid rgba(255,255,255,0.12)" : "none",
                  }}
                >
                  <div style={styles.statNum}>{s.num}</div>
                  <div style={styles.statLabel}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* ── AI BANNER ───────────────────────────────── */}
            <div style={{ padding: "40px 24px 0" }}>
              <div style={styles.aiBanner}>
                <div style={styles.aiBannerLeft}>
                  <span style={{ fontSize: "34px", flexShrink: 0, marginTop: "2px" }}>🤖</span>
                  <div style={{ flex: 1 }}>
                    <div style={styles.aiBannerEyebrow}>My Home Buddha AI Tools</div>
                    <div style={styles.aiBannerTitle}>
AI-Powered Research for Buyers, Sellers, Agents &amp; Homeowners
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "16px" }}>
                  {["🏠 Property Research","📋 Inspection Analysis","🎯 Buyer Readiness","💰 Market Values","🏡 Home Health","📑 Agent Reports"].map((item, i) => (
                    <span key={i} style={{
background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.2)",
borderRadius: "50px", padding: "4px 12px",
fontSize: "11px", fontWeight: "600",
color: "rgba(255,255,255,0.88)",
fontFamily: "'DM Sans', sans-serif",
                    }}>{item}</span>
                  ))}
                </div>

<a href="https://ai.myhomebuddha.com?mode=buyer" target="_blank" rel="noreferrer" onClick={this.openAITools} style={styles.aiBannerBtn}>
🤖 Open AI Tools — Free →
                </a>
              </div>
            </div>

            {/* ── FEATURE CARDS ───────────────────────────── */}
            <div style={styles.featureGrid}>
              <div style={{ textAlign: "center", marginBottom: "36px" }}>
                <span style={styles.sectionEyebrow}>Once You're In, You Get Even More</span>
                <h2 style={{ ...styles.sectionTitle, margin: "0 auto" }}>
Everything Else Home Buddha Unlocks
                </h2>
              </div>
              <Row gutter={[20, 20]} justify="center">
                {features.map((f, i) => (
                  <Col key={i} xs={24} sm={12} md={12} lg={6} xl={6}>
                    <div style={styles.featureCard}
onMouseEnter={e => {
e.currentTarget.style.boxShadow = "0 8px 32px rgba(26,34,128,0.12)";
e.currentTarget.style.transform = "translateY(-3px)";
                      }}
onMouseLeave={e => {
e.currentTarget.style.boxShadow = "none";
e.currentTarget.style.transform = "none";
                      }}
                    >
                      <div style={styles.featureIcon}>
                        <img src={f.img} alt={f.alt} style={{ width: "40px", height: "40px", objectFit: "contain" }} />
                      </div>
                      <div style={styles.featureTitle}>{f.title}</div>
                      <p style={styles.featureBody}>{f.body}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>

            {/* ── MORE REASONS SECTION ────────────────────── */}
            <div style={styles.whySection}>
              <Row gutter={[48, 40]} align="top">
                <Col xs={24} md={10}>
                  <span style={styles.sectionEyebrow}>Also Inside Home Buddha</span>
                  <h2 style={styles.sectionTitle}>A Better Real Estate Experience — For Everyone</h2>
                  <p style={styles.sectionSub}>
The only fully transparent, AI-driven home platform built for buyers, sellers, homeowners,
and agents. No games. No middlemen. Just clarity, control, and smarter decisions.
                  </p>
                  <div style={{ marginTop: "28px" }}>
                    <button style={styles.joinBtn} onClick={() => this.goTo()}>
Join For Free
                    </button>
                  </div>
                </Col>
                <Col xs={24} md={14}>
                  {pillItems.map((p, i) => (
                    <div key={i} style={styles.pillCard}>
                      <div style={styles.pillIcon}>{p.icon}</div>
                      <div>
                        <div style={styles.pillTitle}>{p.title}</div>
                        <p style={styles.pillBody}>{p.body}</p>
                      </div>
                    </div>
                  ))}
                </Col>
              </Row>
            </div>

            {/* ── BOTTOM CTA ──────────────────────────────── */}
            <div style={styles.bottomCTA}>
              <div style={{
display: "inline-block",
background: "rgba(212,146,26,0.18)",
border: "1px solid rgba(212,146,26,0.4)",
borderRadius: "50px", padding: "4px 16px",
fontSize: "11px", fontWeight: "800",
color: T.gold, letterSpacing: "0.1em",
textTransform: "uppercase", marginBottom: "16px",
fontFamily: "'DM Sans', sans-serif",
              }}>
Ready to Get Started?
              </div>
              <h2 style={{
fontFamily: "'DM Sans', sans-serif",
fontSize: "clamp(22px, 3vw, 40px)",
fontWeight: "900", color: T.white,
marginBottom: "12px", lineHeight: "1.2",
              }}>
Claim Your Home.<br />
                <span style={{ color: T.gold }}>Live Safer, Healthier, Wealthier &amp; Happier.</span>
              </h2>
              <p style={{
fontFamily: "'DM Sans', sans-serif",
fontSize: "15px", color: "rgba(255,255,255,0.78)",
maxWidth: "520px", margin: "0 auto 32px",
lineHeight: "1.65",
              }}>
Build your Home Portal yourself for free, or add a $99 Home Advisor visit — guaranteed, or your
$99 is refunded and you keep your Home Portal for life, free.
              </p>
              <div style={{ display: "flex", gap: "14px", justifyContent: "center", flexWrap: "wrap" }}>
                <button style={styles.goldBtn} onClick={this.scrollToClaim}>
📍 Claim My Home →
                </button>
                <button style={styles.joinBtn} onClick={() => this.goTo()}>
Create Free Account
                </button>
              </div>
            </div>

          </Content>
        </Layout>
      </>
    );
  }
}

export default withAppContext(withRouter(Home));
